import { z } from "zod";

export const s3ObjectEntrySchema = z.object({
  key: z.string(),
  lastModified: z.string().optional(),
  size: z.number().optional(),
});

export type S3ObjectEntry = z.infer<typeof s3ObjectEntrySchema>;

export const listBucketObjectsResponseSchema = z.object({
  bucket: z.string().optional(),
  pageSize: z.number().optional(),
  isTruncated: z.boolean().optional(),
  nextContinuationToken: z.string().optional(),
  continuationToken: z.string().optional(),
  objects: z.array(s3ObjectEntrySchema).default([]),
  commonPrefixes: z.array(z.string()).default([]),
});

export type ListBucketObjectsResponse = z.infer<typeof listBucketObjectsResponseSchema>;
